var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8806 12.3116C17.389 12.0086 17.5742 11.3797 17.3072 10.8627L13.0497 2.61664C12.6252 1.79445 11.4136 1.79445 10.9891 2.61664L6.73163 10.8627C6.46467 11.3797 6.64982 12.0086 7.15821 12.3116L11.4157 14.8488C11.7859 15.0694 12.2529 15.0694 12.6231 14.8488L16.8806 12.3116Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9852 21.4924C12.531 22.1692 11.5079 22.1692 11.0536 21.4924L6.53884 14.7661C6.47189 14.6663 6.59116 14.5479 6.6958 14.6103L11.4157 17.4231C11.7859 17.6437 12.2529 17.6437 12.6231 17.4231L17.343 14.6103C17.4477 14.5479 17.5669 14.6663 17.5 14.7661L12.9852 21.4924Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum2);
export default __webpack_public_path__ + "static/media/ethereum-2.fe75556338c4a2e3b472bacef94296f8.svg";
export { ForwardRef as ReactComponent };